// eslint-disable-next-line max-classes-per-file
import { Ref } from '@/decorators/ref';
import { assignOwnProperties } from '@/utils/assignOwnProperties';
import { normalize } from '@/utils/normalize';
import type { IGeoPosition } from '~/api/IGeoPosition';
import type { IPostInfo } from '~/api/IPostInfo';

export class Post implements IPostInfo {
  @Ref address1: string;
  @Ref address2: string;
  @Ref city: string;
  @Ref companyId: string;
  @Ref county: string;
  @Ref id: string;
  @Ref name: string;
  @Ref phone: string;
  @Ref position: IGeoPosition;
  @Ref postalCode: string;
  @Ref region: string;
  @Ref sentTime: string;
  @Ref speedCode: string;
  @Ref status: string;

  constructor(data: Post) {
    assignOwnProperties(this, normalize(data));
  }
}
